// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__D1VQZ","subheader":"ReorderModal_subheader__1-NJf","listWrap":"ReorderModal_listWrap__nA8El"};